import { GAME_COLLECTION_ACTION_TYPE } from "./game-collection.action";

export const GAME_COLLECTION_CONTEXT = {
	getAll: GAME_COLLECTION_ACTION_TYPE.getAll,
};
